import { server_address } from '../../config';

// let server_address = 'http://127.0.0.1:8000/';
// let server_address='https://etymo-5cpb.onrender.com/';
// let server_address='https://gst-server-zdou.onrender.com/';


export async function storeRequest(type, name, email, mobile, description, documents, price = 500, docStatus = 'complete') {
    console.log('in storeRequest')
    const token = localStorage.getItem('token');
    let balance = 0;
    if (!token) {
        console.log('Token missing in storeRequest');
        return
    }
    console.log(`token : ${token}`)


    try {
        const response = await fetch(`${server_address}get_agent_balance/`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ token: token })
            }
        )
        const data = await response.json()
        if (data.result === 'success') {
            balance = data.balance
            console.log(balance)
        } else {
            console.log('Error fetching balance:', data.result);
            return
        }
    } catch (error) {
        console.log(error)
        console.log("can't reach server")
        return
    }

    if (balance < price) {
        alert(`Request submission failed. Required: ${price}, available: ${balance}`)
        return
    }

    let formData = new FormData()
    for (let i = 0; i < documents.length; i++) {
        formData.append('documents', documents[i]);
    }
    formData.append('type', type);
    formData.append('name', name);
    formData.append('email', email);
    formData.append('mobile', mobile);
    formData.append('description', description);
    formData.append('token', token);
    formData.append('doc_status', docStatus);
    console.log('in storeRequest1');
    try {
        const response = await fetch(`${server_address}submit_request/`,
            {
                method: 'POST',
                body: formData,
            }
        )
        const data = await response.json();
        if (data.message === 'submitted') {
            alert('Service Request Submitted Successfully')
        } else {
            alert(data.message)
        }

        return data.message
    } catch (error) {
        console.log('error')
        alert("can't reach server")
    }
}

export async function getRequestData() {
    const token = localStorage.getItem('token');
    if (!token) {
        console.log('Token missing in getRequestData');
        return []
    }
    try {
        const response = await fetch(`${server_address}get_request_data/`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ token: token })
            }
        );
        const data = await response.json()
        console.log(data)
        console.log(data.result)
        if (data.message === 'success') {
            return data.result
        } else {
            console.log('Error fetching requests:', data.message);
            return [];
        }

    } catch (error) {
        console.error('Network error fetching requests:', error);
        return [];
    }
}

export async function getRequestDocument(id) {
    try {
        const response = await fetch(`${server_address}get_request_document/`,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ id: id })
            }
        );
        const data = await response.json()
        console.log(data)
        if (!data.result || data.result.length === 0) {
            console.log("returning empty data")
            return []
        }
        console.log("returning data")
        return data.result

    } catch (error) {
        console.log(error)
    }
}

export async function showRequestDocument(id) {
    try {
        const response = await fetch(`${server_address}get_request_document_data/`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id: id })

            }
        );
        const blob = await response.blob();
        console.log(blob)
        const url = URL.createObjectURL(blob);
        window.open(url);
        //start
        // const link = document.createElement('a');
        // link.href = url;
        // link.download = 'example'; // You can also dynamically set this from the response
        // document.body.appendChild(link);
        // link.click();
        //end
    } catch (error) {
        console.log(error)

    }
}

export async function downloadRequestDocument(id, name) {
    try {
        const response = await fetch(`${server_address}get_request_document_data/`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id: id })

            }
        );
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = name;
        document.body.appendChild(link);
        link.click();

    } catch (error) {
        console.log(error);
        alert("error while downloading document");

    }
}

export async function downloadRequestCompletionDocument(id, name) {
    try {
        const response = await fetch(`${server_address}get_request_completion_document_data/`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id: id })

            }
        );
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = name;
        document.body.appendChild(link);
        link.click();

    } catch (error) {
        console.log(error);
        alert("error while downloading document");

    }
}

export async function showPaymentRequestDocument(id) {
    console.log(`document:${id}`)
    try {
        const response = await fetch(`${server_address}get_payment_request_document_data/`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id: id })

            }
        );
        const blob = await response.blob();
        console.log(blob)
        const url = URL.createObjectURL(blob);
        window.open(url);
    } catch (error) {
        console.log(error)

    }
}


export async function storePaymentRequest(paymentMethod, name, amount, bankName, accountNumber, ifscCode, upiId, document) {
    console.log('in storePaymentRequest')
    const token = localStorage.getItem('token');

    if (!token) {
        console.log('Token missing in storePaymentRequest');
        return
    }
    console.log(`token : ${token}`)

    let formData = new FormData()  //paymentMethod, name, bankName, accountNumber, ifscCode, upiId, document
    for (let i = 0; i < document.length; i++) {
        formData.append('documents', document[i]);
    }
    formData.append('paymentMethod', paymentMethod);
    formData.append('name', name);
    formData.append('amount', amount);
    formData.append('bankName', bankName);
    formData.append('accountNumber', accountNumber);
    formData.append('ifscCode', ifscCode);
    formData.append('token', token);
    formData.append('upiId', upiId);
    console.log('in storeRequest1');
    try {
        const response = await fetch(`${server_address}submit_payment_request/`,
            {
                method: 'POST',
                body: formData,
            }
        )
        const data = await response.json();
        // alert(data.message)
        return data.message
    } catch (error) {
        console.log('error')
        // alert("can't reach server")
        return ("can't reach server")
    }
}

// getPaymentRequestData

export async function getPaymentRequestData() {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${server_address}get_payment_request_data/`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ token: token })
            }
        );
        const data = await response.json()
        if (data.message === "success") {
            return data.result
        } else {
            console.log('Error fetching payment requests:', data.message);
            return [];
        }

    } catch (error) {
        console.log(error)
        return [];
    }
}

export async function getCaCSData(available_now = false) {
    console.log('in getCaCSData', available_now)
    const token = localStorage.getItem('token');
    if (!token) {
        console.log('Token missing in getCaCSData');
        return []
    }
    console.log(token)
    try {
        const response = await fetch(`${server_address}get_ca_cs_data/`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ token: token, available_now: available_now })
            }
        );

        const data = await response.json()
        console.log('in getCACSdata')
        console.log(data.result)
        console.log(data.message)
        if (data.message === 'success') {
            return data.result
        } else {
            console.log('Error fetching CA/CS data:', data.message);
            return [];
        }

    } catch (error) {
        console.error('Network error fetching CA/CS data:', error);
        return [];
    }
}


export async function getCaCsDocument(id) {
    try {
        const response = await fetch(`${server_address}get_ca_cs_document/`,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ id: id })
            }
        );
        const data = await response.json()
        console.log(data)
        if (!data.result || data.result.length === 0) {
            console.log("returning empty data")
            return []
        }
        console.log("returning data")
        return data.result

    } catch (error) {
        console.log(error)
    }
}

export async function showCaCsDocument(id) {
    try {
        const response = await fetch(`${server_address}get_ca_cs_document_data/`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id: id })

            }
        );
        const blob = await response.blob();
        console.log(blob)
        const url = URL.createObjectURL(blob);
        window.open(url);
    } catch (error) {
        console.log(error)

    }
}

export async function getBalance() {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            console.log('Token missing in getBalance');
            return 0
        }
        const response = await fetch(`${server_address}get_agent_balance/`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ token: token })
            }
        )
        const data = await response.json()
        if (data.result === 'success') {
            return data.balance
        } else {
            console.log('Error fetching balance:', data.result);
            return data.balance || 0;
        }
    }
    catch (error) {
        console.log(error)

    }
}


export async function getTransactionData() {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${server_address}get_transaction_data/`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ token: token })
            }
        );
        const data = await response.json()
        if (data.message === 'success') {
            return data.result
        } else {
            console.log('Error fetching transactions:', data.message);
            return [];
        }

    } catch (error) {
        console.error('Network error fetching transactions:', error);
        return [];
    }
}




export async function completeWork(request_id, description, documents) {
    console.log('in completeWork')
    console.log(documents)
    const token = localStorage.getItem('token');

    let formData = new FormData()
    for (let i = 0; i < documents.length; i++) {
        formData.append('documents', documents[i]);
        console.log('document uploaded');
    }

    formData.append('description', description);
    formData.append('request_id', request_id);
    formData.append('token', token);
    console.log('in completeWork1');
    try {
        const response = await fetch(`${server_address}complete_request/`,
            {
                method: 'POST',
                body: formData,
            }
        )
        const data = await response.json();

        return data.message
    } catch (error) {
        console.log('error')

    }
}

export async function getRequestCompletionDocument(id) {
    try {
        const response = await fetch(`${server_address}get_request_completion_document/`,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ id: id })
            }
        );
        const data = await response.json()
        console.log(data)
        if (!data.result || data.result.length === 0) {
            console.log("returning empty data")
            return []
        }
        console.log("returning data")
        return data.result

    } catch (error) {
        console.log(error)
    }
}


export async function showRequestCompletionDocument(id) {
    try {
        const response = await fetch(`${server_address}get_request_completion_document_data/`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id: id })

            }
        );
        const blob = await response.blob();
        console.log(blob)
        const url = URL.createObjectURL(blob);
        window.open(url);
    } catch (error) {
        console.log(error)

    }
}


export async function getAgentDataList() {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            console.log('Token missing in getAgentDataList');
            return []
        }
        const response = await fetch(`${server_address}get_agent_data_list/`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ token: token })
            }
        )
        const data = await response.json()
        console.log(data.result);
        return data.result
    } catch (error) {
        console.error('Network error getting agent data list:', error);
        return [];
    }
}

export async function getServices() {
    try {
        const response = await fetch(`${server_address}get_services/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const data = await response.json();
        if (data.message === 'success') {
            return data.result;
        } else {
            console.error('Error fetching services:', data.message);
            return [];
        }
    } catch (error) {
        console.error('Network error fetching services:', error);
        return [];
    }
}

export async function addService(name, price, required_documents, category_id) {
    try {
        const response = await fetch(`${server_address}add_service/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ name, price, required_documents, category_id })
        });
        const data = await response.json();
        return data.message;
    } catch (error) {
        console.error('Network error adding service:', error);
        return 'error';
    }
}

export async function updateService(id, name, price, required_documents, category_id) {
    try {
        const response = await fetch(`${server_address}update_service/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id, name, price, required_documents, category_id })
        });
        const data = await response.json();
        return data.message;
    } catch (error) {
        console.error('Network error updating service:', error);
        return 'error';
    }
}

export async function deleteService(id) {
    try {
        const response = await fetch(`${server_address}delete_service/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id })
        });
        const data = await response.json();
        return data.message;
    } catch (error) {
        console.error('Network error deleting service:', error);
        return 'error';
    }
}

export async function getServiceCategories() {
    try {
        const response = await fetch(`${server_address}get_service_categories/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const data = await response.json();
        if (data.message === 'success') {
            return data.result;
        } else {
            console.error('Error fetching categories:', data.message);
            return [];
        }
    } catch (error) {
        console.error('Network error fetching categories:', error);
        return [];
    }
}

export async function addServiceCategory(name) {
    try {
        const response = await fetch(`${server_address}add_service_category/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ name })
        });
        const data = await response.json();
        return data.message;
    } catch (error) {
        console.error('Network error adding category:', error);
        return 'error';
    }
}

export async function updateServiceCategory(id, name) {
    try {
        const response = await fetch(`${server_address}update_service_category/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id, name })
        });
        const data = await response.json();
        return data.message;
    } catch (error) {
        console.error('Network error updating category:', error);
        return 'error';
    }
}

export async function deleteServiceCategory(id) {
    try {
        const response = await fetch(`${server_address}delete_service_category/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id })
        });
        const data = await response.json();
        return data.message;
    } catch (error) {
        console.error('Network error deleting category:', error);
        return 'error';
    }
}

export async function updateCaCsData(id, data, files) {
    try {
        const formData = new FormData();
        formData.append('id', id);
        // Append all text fields
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                formData.append(key, data[key]);
            }
        }
        // Append files if they exist
        if (files.certificate) formData.append('certificate', files.certificate);
        if (files.idProof) formData.append('idProof', files.idProof);

        const response = await fetch(`${server_address}update_ca_cs/`, {
            method: 'POST',
            body: formData,
        });
        const result = await response.json();
        return result.message;
    } catch (error) {
        console.error('Network error updating CA/CS data:', error);
        return 'error';
    }
}

export async function getCaCsSlots(ca_cs_id) {
    try {
        const response = await fetch(`${server_address}get_ca_cs_slots/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ ca_cs_id })
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching CA/CS slots:', error);
        return { result: [], message: 'error' };
    }
}

export async function updateCaCsSlots(ca_cs_id, slots) {
    try {
        const response = await fetch(`${server_address}update_ca_cs_slots/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ ca_cs_id, slots })
        });
        const data = await response.json();
        return data.message;
    } catch (error) {
        console.error('Error updating CA/CS slots:', error);
        return 'error';
    }
}

export async function getCaCsSpecialSlots(ca_cs_id) {
    try {
        const response = await fetch(`${server_address}get_ca_cs_special_slots/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ ca_cs_id })
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching CA/CS special slots:', error);
        return { result: [], message: 'error' };
    }
}

export async function updateCaCsSpecialSlots(ca_cs_id, date, slots) {
    try {
        const response = await fetch(`${server_address}update_ca_cs_special_slots/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ ca_cs_id, date, slots })
        });
        const data = await response.json();
        return data.message;
    } catch (error) {
        console.error('Error updating CA/CS special slots:', error);
        return 'error';
    }
}


export async function getMyCacsData() {
    const token = localStorage.getItem('token');
    if (!token) {
        console.log('Token missing in getMyCacsData');
        return null;
    }
    try {
        const response = await fetch(`${server_address}get_my_cacs_data/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ token: token })
        });
        const data = await response.json();
        if (data.message === 'success') {
            // Backend returns a tuple, convert it to a more usable object if needed
            // Based on gst_tbl_ca_cs structure: 
            // 0:id, 1:name, 2:role, 3:specialization, 4:email, 5:mobile, 6:regNumber, 7:workingDays, 8:timezone, 9:created_at, 10:assigned_request
            const r = data.result;
            return {
                id: r[0],
                name: r[1],
                role: r[2],
                specialization: r[3],
                email: r[4],
                phone: r[5],
                registrationNumber: r[6],
                workingDays: r[7],
                timezone: r[8],
                assigned_request: r[10]
            };
        } else {
            console.error('Error fetching my CA/CS data:', data.message);
            return null;
        }
    } catch (error) {
        console.error('Network error fetching my CA/CS data:', error);
        return null;
    }
}

export async function adminPayAmount(requestId, amount, paymentMethod, transactionId, notes) {
    const token = localStorage.getItem('token');
    if (!token) {
        console.log('Token missing in adminPayAmount');
        return 'error';
    }
    try {
        const response = await fetch(`${server_address}admin_pay_amount/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ requestId, amount, paymentMethod, transactionId, notes, token })
        });
        const data = await response.json();
        return data.message;
    } catch (error) {
        console.error('Network error in adminPayAmount:', error);
        return 'error';
    }
}

export async function getAdminBankDetails() {
    try {
        const response = await fetch(`${server_address}get_admin_bank_details/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const data = await response.json();
        if (data.message === 'success') {
            return data.result;
        } else {
            console.log('Error fetching admin bank details:', data.message);
            return null;
        }
    } catch (error) {
        console.error('Network error fetching admin bank details:', error);
        return null;
    }
}

export async function updateAdminBankDetails(bankName, accountName, accountNumber, ifscCode, upiId, upiQRCode) {
    const token = localStorage.getItem('token');
    if (!token) {
        console.log('Token missing in updateAdminBankDetails');
        return 'error';
    }
    try {
        const formData = new FormData();
        formData.append('bankName', bankName);
        formData.append('accountName', accountName);
        formData.append('accountNumber', accountNumber);
        formData.append('ifscCode', ifscCode);
        formData.append('upiId', upiId);
        formData.append('token', token);
        if (upiQRCode) {
            formData.append('upiQRCode', upiQRCode);
        }

        const response = await fetch(`${server_address}update_admin_bank_details/`, {
            method: 'POST',
            body: formData
        });
        const data = await response.json();
        return data.message;
    } catch (error) {
        console.error('Network error updating admin bank details:', error);
        return 'error';
    }
}

export async function getCaCsBankDetails(cacs_id = null) {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${server_address}get_cacs_bank_details/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ cacs_id, token })
        });
        const data = await response.json();
        if (data.message === 'success') {
            return data.result;
        } else {
            console.log('Error fetching CA/CS bank details:', data.message);
            return null;
        }
    } catch (error) {
        console.error('Network error fetching CA/CS bank details:', error);
        return null;
    }
}

export async function updateCaCsBankDetails(bankName, accountName, accountNumber, ifscCode, upiId) {
    const token = localStorage.getItem('token');
    if (!token) {
        console.log('Token missing in updateCaCsBankDetails');
        return 'error';
    }
    try {
        const response = await fetch(`${server_address}update_cacs_bank_details/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ bankName, accountName, accountNumber, ifscCode, upiId, token })
        });
        const data = await response.json();
        return data.message;
    } catch (error) {
        console.error('Network error updating CA/CS bank details:', error);
        return 'error';
    }
}

export function getAdminBankQRCodeUrl() {
    return `${server_address}get_admin_bank_qr_code/`;
}
